import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import Api from "./api";
import {
  fetchFeatureFlagsSuccess,
  fetchFeatureFlagsFailure,
  updateFeatureFlagSuccess,
  updateFeatureFlagFailure,
  fetchFeatureFlagSuccess,
  fetchFeatureFlagFailure,
} from "./actions";
import {
  FETCH_FEATURE_FLAGS_REQUEST,
  UPDATE_FEATURE_FLAG_REQUEST,
  FETCH_FEATURE_FLAG_REQUEST,
} from "./types";

const extractPayload = (response) => {
  const body = response?.data ?? response;
  if (
    body &&
    typeof body === "object" &&
    Object.prototype.hasOwnProperty.call(body, "data")
  ) {
    return body.data;
  }
  return body;
};

const extractError = (error, fallback = "Something went wrong.") => {
  return (
    error?.response?.data?.message ||
    error?.response?.data?.error ||
    error?.message ||
    fallback
  );
};

function* fetchFeatureFlagsSaga() {
  try {
    const res = yield call(Api.fetchFeatureFlags);
    const payload = extractPayload(res);
    const items = Array.isArray(payload) ? payload : [];
    yield put(fetchFeatureFlagsSuccess(items));
  } catch (error) {
    yield put(fetchFeatureFlagsFailure(extractError(error, "Unable to fetch feature flags.")));
  }
}

function* updateFeatureFlagSaga(action) {
  const { name, is_enabled } = action?.payload || {};
  try {
    const res = yield call(Api.updateFeatureFlag, name, is_enabled);
    const payload = extractPayload(res);
    const flag =
      Array.isArray(payload) && payload.length
        ? payload.find((item) => item?.name === name) || payload[0]
        : payload;

    yield put(
      updateFeatureFlagSuccess({
        name,
        flag:
          flag && typeof flag === "object"
            ? flag
            : { name, is_enabled },
      })
    );
  } catch (error) {
    yield put(
      updateFeatureFlagFailure({
        name,
        error: extractError(error, `Failed to update ${name}.`),
      })
    );
  }
}

function* fetchFeatureFlagSaga(action) {
  const { name } = action?.payload || {};
  if (!name) {
    yield put(
      fetchFeatureFlagFailure({
        name,
        error: "Feature flag name is required.",
      })
    );
    return;
  }

  try {
    const res = yield call(Api.fetchFeatureFlag, name);
    const payload = extractPayload(res);
    const flag =
      Array.isArray(payload) && payload.length
        ? payload.find((item) => item?.name === name) || payload[0]
        : payload;

    yield put(
      fetchFeatureFlagSuccess({
        name,
        flag: flag && typeof flag === "object" ? flag : { name },
      })
    );
  } catch (error) {
    yield put(
      fetchFeatureFlagFailure({
        name,
        error: extractError(error, `Unable to fetch ${name}.`),
      })
    );
  }
}

function* watchFeatureFlagsAsync() {
  yield takeLatest(FETCH_FEATURE_FLAGS_REQUEST, fetchFeatureFlagsSaga);
  yield takeEvery(UPDATE_FEATURE_FLAG_REQUEST, updateFeatureFlagSaga);
  yield takeEvery(FETCH_FEATURE_FLAG_REQUEST, fetchFeatureFlagSaga);
}

export default watchFeatureFlagsAsync;
